import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { stackSchematicThemeModule } from './modules/stackschematic';
import { stackSchematicGuideModule } from './modules/guide';
import { stackSchematicFleetModule } from './modules/fleet';
import { stackSchematicConnectModule } from './modules/connect';
import { stackSchematicBlueprintModule } from './modules/blueprint';
import { stackSchematicDiscoveryModule } from './modules/discovery';
import { stackSchematicRecoverModule } from './modules/recover';
import { stackSchematicBackupsModule } from './modules/backups';
import { stackSchematicNotificationsModule } from './modules/notifications';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { stackSchematicInboxModule } from './modules/inbox';
import { stackSchematicAttributionsModule } from './modules/attributions';
import { stackSchematicUptimeModule } from './modules/uptime';

export default createApp({
  features: [catalogPlugin, navModule, homeModule, stackSchematicThemeModule, stackSchematicGuideModule, stackSchematicFleetModule, stackSchematicConnectModule, stackSchematicBlueprintModule, stackSchematicDiscoveryModule, stackSchematicRecoverModule, stackSchematicBackupsModule, stackSchematicNotificationsModule, techdocsPlugin, stackSchematicInboxModule, stackSchematicAttributionsModule, stackSchematicUptimeModule],
});
